import type { HttpErrorResponse } from '@angular/common/http';
import type { ITextSnippetDTO } from '@modeso/types__aumico-lib-annualreport-be';
import { createAction, props } from '@ngrx/store';

export const CreateTextSnippet = createAction(
    '[Aumico-TextSnippet] CreateTextSnippet',
    props<{ payload: ITextSnippetDTO }>(),
);
export const OnCreateTextSnippetSuccessfully = createAction(
    '[Aumico-TextSnippet] OnCreateTextSnippetSuccessfully',
    props<{ payload: ITextSnippetDTO }>(),
);
export const OnCreateTextSnippetFailed = createAction(
    '[Aumico-TextSnippet] OnCreateTextSnippetFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const GetAllTextSnippets = createAction('[Aumico-AnnualReport] GetAllTextSnippets');
export const OnGetAllTextSnippetsSuccessfully = createAction(
    '[Aumico-AnnualReport] OnGetAllTextSnippetsSuccessfully',
    props<{ payload: ITextSnippetDTO[] }>(),
);
export const OnGetAllTextSnippetsFailed = createAction(
    '[Aumico-AnnualReport] OnGetAllTextSnippetsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const DeleteTextSnippets = createAction(
    '[Aumico-AnnualReport] DeleteTextSnippets',
    props<{ textSnippetsIds: string[] }>(),
);
export const OnDeleteTextSnippetsSuccessfully = createAction(
    '[Aumico-AnnualReport] OnDeleteTextSnippetsSuccessfully',
    props<{ textSnippetsIds: string[] }>(),
);
export const OnDeleteTextSnippetsFailed = createAction(
    '[Aumico-AnnualReport] OnDeleteTextSnippetsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const UpdateTextSnippet = createAction(
    '[Aumico-AnnualReport] UpdateTextSnippet',
    props<{ payload: ITextSnippetDTO }>(),
);
export const OnUpdateTextSnippetSuccessfully = createAction(
    '[Aumico-AnnualReport] OnUpdateTextSnippetSuccessfully',
    props<{ payload: ITextSnippetDTO }>(),
);
export const OnUpdateTextSnippetFailed = createAction(
    '[Aumico-AnnualReport] OnUpdateTextSnippetFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const GetTextSnippetById = createAction(
    '[Aumico-AnnualReport] GetTextSnippetById',
    props<{ payload: string }>(),
);
export const OnGettingTextSnippetByIdSuccessfully = createAction(
    '[Aumico-Companies] OnGettingTextSnippetByIdSuccessfully',
    props<{ payload: ITextSnippetDTO }>(),
);
export const OnGettingTextSnippetByIdFailed = createAction(
    '[Aumico-Companies] OnGettingTextSnippetByIdFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const ResetSelectedTextSnippet = createAction('[Aumico-AnnualReport] ResetSelectedTextSnippet');
